/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import "./App.css";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { useStateValue } from "./StateProvider";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import Divider from "@material-ui/core/Divider";
import Typewriter from "typewriter-effect";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const divStyle = {
  color: "black",
};

function Home() {
  const classes = useStyles();
  const [{ user }] = useStateValue();
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <div class="container-fluid">
        <div class="background">
          <div class="cube"></div>
          <div class="cube"></div>
          <div class="cube"></div>
          <div class="cube"></div>
          <div class="cube"></div>
        </div>

        <header class="top">
          <section class="header-content">
            {user && user.name ? (
              <h1>
                <b>
                  <Typewriter
                    options={{
                      strings: ["Welcome", user.name],
                      autoStart: true,
                      loop: true,
                    }}
                  />
                  😊🍚
                </b>
              </h1>
            ) : (
              <h1>
                <b>
                  <Typewriter
                    options={{
                      strings: ["Welcome"],
                      autoStart: true,
                      loop: true,
                    }}
                  />
                  😊🍚
                </b>
              </h1>
            )}

            <p>
              Easing the process of searching a comfortable and affordable
              canteens for you!
            </p>
            <div>
              <img src="cantenia.png" style={{ maxWidth: "15%" }}></img>
            </div>
            <div className={classes.root}>
              <div class="container1">
                <div class="vertical-center">
                  <Button variant="contained" onClick={handleClickOpen}>
                    Instructions
                  </Button>
                </div>
              </div>
            </div>
          </section>
        </header>

        {/* Instructions */}
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          style={{ borderRadius: "100px" }}
        >
          <DialogContent>
            <div>
              <h1 style={divStyle}>Instructions</h1>
              <h2>For those who do not own any canteen</h2>
              <br />
              <ul>
                <li className="instruction">
                  Visit <strong>Search Canteens</strong>.
                </li>
                <li className="instruction">
                  Create an account to <strong>bookmark</strong> the preferred
                  canteens.
                </li>
                <li className="instruction">
                  View bookmarked canteens in <strong>User Profile</strong>.
                </li>
              </ul>
              <Divider />

              <h2 className="instruction_list">For those who own a canteen</h2>
              <br />
              <ul>
                <li className="instruction">
                  Create your account by visiting <b>Log In</b>.
                </li>
                <li className="instruction">
                  Visit <strong>My Canteen</strong> and fill up your canteen
                  details.
                </li>
                <li className="instruction">
                  Verify the <strong>Google Map</strong> link once you have
                  entered the Canteen Name, State, and City.
                </li>
                <li className="instruction">
                  You will be redirected to Google Maps, confirm your canteen
                  and proceed with further information.
                </li>
                <li className="instruction">
                  {" "}
                  If it's not your canteen link, replace it with the canteen
                  link in the field and you are set to go!
                </li>
                <br />
                <center>
                  <strong>⬇ For Example ⬇</strong>
                </center>
                <br />
                <div style={{ width: "500px", height: "fit-content" }}>
                  <img
                    src="link.png"
                    style={{
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "20px",
                    }}
                  />
                </div>
              </ul>
            </div>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}

export default Home;
